/**
 * Convierte cualquier valor (string u objeto inesperado devuelto por un
 * análisis de IA) en un texto seguro para renderizar en React.
 *
 * Motivo: los análisis de WhatsApp/documentos esperan listas de strings
 * (ej. notas_importantes, peticiones_especiales), pero el LLM a veces
 * devuelve objetos (ej. {archivo, fecha, contenido}) para chats largos o
 * con adjuntos. Renderizar ese objeto directamente como `{item}` revienta
 * React con "Objects are not valid as a React child" (error #31).
 */
export function toDisplayText(item) {
  if (item == null) return '';
  if (typeof item === 'string') return item;
  if (typeof item === 'object') {
    return Object.values(item)
      .filter((v) => v !== null && v !== undefined && v !== '')
      .map((v) => (typeof v === 'object' ? toDisplayText(v) : String(v)))
      .join(' - ');
  }
  return String(item);
}
